/**
 * Web application entry: thin bootstrap over the shell library. Everything —
 * module-table seeding, the boot page, and the UI-renderer handoff — lives
 * in @deepseek-ai/dsh-client-web; this file only finds the mount point.
 */
import { AppWebEntry } from '@deepseek-ai/dsh-client-web'
import { ensureStandaloneHarnessBoot } from './standalone-boot.ts'

const el = document.getElementById('root')
if (el === null) throw new Error('web app: missing #root')
void (async () => {
  try {
    await ensureStandaloneHarnessBoot()
    await new AppWebEntry(el).run()
  } catch (reason) {
    const message = reason instanceof Error ? reason.message : String(reason)
    console.error(reason)
    el.replaceChildren(document.createTextNode(`Web boot failed: ${message}`))
  }
})()
